// Heavy Lies - Hide/Show Header on Scroll
let lastScrollTop = 0;
const header = document.querySelector('.section-header');

if (header) {
  console.log('Header found:', header);

  window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > 100) {
      // Past the initial section
      if (scrollTop > lastScrollTop) {
        // Scrolling DOWN - hide header
        console.log('Scrolling DOWN - adding header-hidden');
        header.classList.add('header-hidden');
      } else {
        // Scrolling UP - show header
        console.log('Scrolling UP - removing header-hidden');
        header.classList.remove('header-hidden');
      }
    } else {
      // At top of page
      header.classList.remove('header-hidden');
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }, { passive: true });
} else {
  console.error('Header not found! Looking for .section-header');
}
